import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/countries/form'
import { api, actionCreators } from 'store/modules/countries'

const metadata = {
  icon: 'map',
  page: 'countries',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
